import React from 'react';
import { Dropdown, Menu } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Spin as AntdSpin } from 'antd';
import { useFelaEnhanced } from 'hooks';

import * as felaRules from './ConfirmButtons.rules';
import { CONFIRMATION_ACTION } from 'modules/incidents/constants';

export interface GeneralUploadButtonsProps {
    onConfirm: () => void;
    onEdit: () => void;
    loadingIndicator?: string;
    submitting: boolean;
}

export const ConfirmButtons = ({ onConfirm, onEdit, loadingIndicator, submitting }: GeneralUploadButtonsProps) => {
    const { styles } = useFelaEnhanced(felaRules);
    const isLoading = !!loadingIndicator && loadingIndicator === CONFIRMATION_ACTION;

    return (
        <div data-test-id="validation-buttons" className={styles.buttonContainer}>
            <Dropdown.Button
                data-test-id="validation-complete"
                className={isLoading ? styles.buttonLoading : styles.button}
                type="primary"
                trigger={['click']}
                disabled={submitting}
                onClick={onConfirm}
                overlay={
                    <Menu>
                        <Menu.Item
                            key="edit-incident"
                            data-test-id="validation-edit"
                            className={styles.editMenuItem}
                            onClick={onEdit}
                        >
                            <FormattedMessage id="page.incidents.table.edit.button" />
                        </Menu.Item>
                    </Menu>
                }
            >
                {isLoading ? <AntdSpin /> : <FormattedMessage id="page.incidents.table.validation.button.complete" />}
            </Dropdown.Button>
        </div>
    );
};
